import { Button } from '@/components/Button/Button';
import { useAppTranslation } from '@/hooks/useAppTranslation';
import { Ionicons } from '@expo/vector-icons';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { useCallback } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { H2, SizableText, YStack, getTokens } from 'tamagui';
import { appConfig as tamaguiConfig } from 'tamagui.config';

export default function ReportCreationImportSuccessScreen(): React.ReactNode {
  const { t } = useAppTranslation();
  const router = useRouter();
  const { published, draft, error } = useLocalSearchParams<{
    published?: string;
    draft?: string;
    error?: string;
  }>();
  const insets = useSafeAreaInsets();
  const uiTokens = getTokens();

  const handleValidate = useCallback(() => {
    router.replace('/reports');
  }, [router]);

  const iconSize = uiTokens.size.$3.val;
  const iconContainerSize = uiTokens.size.$5.val;

  return (
    <YStack
      flex={1}
      paddingHorizontal="$true"
      paddingTop={insets.top + uiTokens.space.$4.val}
      paddingBottom={Math.max(insets.bottom, uiTokens.space.$4.val)}
    >
      <YStack flex={1} alignItems="center" justifyContent="center" gap="$3">
        <YStack
          width={iconContainerSize}
          height={iconContainerSize}
          borderRadius="$circle"
          backgroundColor="$successBg"
          alignItems="center"
          justifyContent="center"
        >
          <Ionicons
            name="checkmark"
            size={iconSize}
            color={tamaguiConfig.tokens?.color?.success?.val}
          />
        </YStack>

        <YStack alignItems="center" gap="$2">
          <H2 textAlign="center">
            {t('reportCreation.success.csvImportResultTitle')}
          </H2>
          <SizableText size="$2" textAlign="center" color="$secondary75">
            {t('reportCreation.success.csvImportResultSubtitle')}
          </SizableText>
          <SizableText size="$2" textAlign="center" color="$secondary75">
            {t('reportCreation.success.csvImportResultPublished', {
              count: Number.parseInt(published ?? '0', 10) || 0,
            })}
          </SizableText>
          <SizableText size="$2" textAlign="center" color="$secondary75">
            {t('reportCreation.success.csvImportResultDraft', {
              count: Number.parseInt(draft ?? '0', 10) || 0,
            })}
          </SizableText>
          <SizableText size="$2" textAlign="center" color="$secondary75">
            {t('reportCreation.success.csvImportResultError', {
              count: Number.parseInt(error ?? '0', 10) || 0,
            })}
          </SizableText>
        </YStack>
      </YStack>

      <Button
        title={t('reportCreation.success.validateButton')}
        onPress={handleValidate}
        width="100%"
      />
    </YStack>
  );
}
